<!--
 * @Author: your name
 * @Date: 2020-05-09 15:27:32
 * @LastEditTime: 2020-05-09 18:44:53
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \zlonmarinesite\src\components\CpaTcpa\cpatcpa.vue
 -->
<template>
  <el-dialog title="DCPA/TCPA" :visible.sync="dialogVisible" width="900px" :before-close="handleClose">
    <table>
      <tr>
        <td>
          <h5 style="text-align:left">本船：</h5>
          <table style="border:1px solid #333;border-collapse:separate; border-spacing:0px 10px;">
            <tr>
              <td style="padding-left:10px;">纬度：</td>
              <td>
                <el-input-number v-model="requestParam.ospos.y" width="100px"></el-input-number>
              </td>
              <td>°</td>
              <td style="padding-right:10px;padding-left:10px;">
                <el-radio v-model="isosposS" label="1">南纬</el-radio>
                <!-- 0-90 -->
                <el-radio v-model="isosposS" label="2">北纬</el-radio>
              </td>
            </tr>
            <tr>
              <td style="padding-left:10px;">经度：</td>
              <td>
                <el-input-number v-model="requestParam.ospos.x" width="100px"></el-input-number>
              </td>
              <td>°</td>
              <td style="padding-right:10px;padding-left:10px;">
                <el-radio v-model="isosposW" label="1">东经</el-radio>
                <!-- 0-90 -->
                <el-radio v-model="isosposW" label="2">西经</el-radio>
              </td>
            </tr>
            <tr>
              <td style="padding-left:10px;">航向：</td>
              <td>
                <el-input-number v-model="requestParam.courses" width="100px"></el-input-number>
              </td>
              <td>°</td>
              <td>

              </td>
            </tr>
            <tr>
              <td style="padding-left:10px;">航速：</td>
              <td>
                <el-input-number v-model="requestParam.speeds" width="100px"></el-input-number>
              </td>
              <td>kn</td>
              <td>

              </td>
            </tr>
          </table>
        </td>
        <td width="20px;">

        </td>
        <td>
          <h5 style="text-align:left">目标船：</h5>
          <table style="border:1px solid #333;border-collapse:separate; border-spacing:0px 10px;">
            <tr>
              <td style="padding-left:10px;">纬度：</td>
              <td>
                <el-input-number v-model="requestParam.tspos.y" width="100px"></el-input-number>
              </td>
              <td>°</td>
              <td style="padding-right:10px;padding-left:10px;">
                <el-radio v-model="istsposS" label="1">南纬</el-radio>
                <!-- 0-90 -->
                <el-radio v-model="istsposS" label="2">北纬</el-radio>
              </td>
            </tr>
            <tr>
              <td style="padding-left:10px;">经度：</td>
              <td>
                <el-input-number v-model="requestParam.tspos.x" width="100px"></el-input-number>
              </td>
              <td>°</td>
              <td style="padding-right:10px;padding-left:10px;">
                <el-radio v-model="istsposW" label="1">东经</el-radio>
                <!-- 0-90 -->
                <el-radio v-model="istsposW" label="2">西经</el-radio>
              </td>
            </tr>
            <tr style="padding-left:10px;">
              <td style="padding-left:10px;">航向：</td>
              <td>
                <el-input-number v-model="requestParam.coursee" width="100px"></el-input-number>
              </td>
              <td>°</td>
              <td>

              </td>
            </tr>
            <tr>
              <td style="padding-left:10px;">航速：</td>
              <td>
                <el-input-number v-model="requestParam.speede" width="100px"></el-input-number>
              </td>
              <td>kn</td>
              <td>

              </td>
            </tr>
          </table>
        </td>
      </tr>
    </table>
    <table style="border:1px solid #333;text-align:center; width:600px;margin-top:20px;margin-left:100px;">
      <tr>
        <td width="50%">
          <el-button @click="calc">计算</el-button>
        </td>
        <td width="50%">
          <table style="border-collapse:separate; border-spacing:0px 10px;">
            <tr>
              <td>距离</td>
              <td>
                <el-input v-model="result.dRange"></el-input>
              </td>
              <td>nmile</td>
            </tr>
            <tr>
              <td>方位</td>
              <td>
                <el-input v-model="result.dBearing"></el-input>
              </td>
              <td>°</td>
            </tr>
            <tr>
              <td>DCPA</td>
              <td>
                <el-input v-model="result.dCPA"></el-input>
              </td>
              <td>nmile</td>
            </tr>
            <tr>
              <td>TCPA</td>
              <td>
                <el-input v-model="result.dTCPA"></el-input>
              </td>
              <td>min</td>
            </tr>
          </table>
        </td>
      </tr>
    </table>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleClose">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import axios from 'axios'
  export default {
    data() {
      return {
        radio: '1',
        isosposS: '2',
        isosposW: '1',
        istsposS: '2',
        istsposW: '1',
        result: {
          dRange: 0,
          dBearing: 0,
          dCPA: 0,
          dTCPA: 0
        },
        requestParam: {
          ospos: {
            x: 121.71499,
            y: 38.95112
          },
          tspos: {
            x: 121.717058,
            y: 38.94263166
          },
          courses: 180,
          speeds: 7.07,
          coursee: 68.48,
          speede: 10,
        }
      }
    },
    props: ['dialogVisible'],
    methods: {
      handleClose(done) {
        this.$emit('update:dialogVisible', false); // 直接修改父组件的属性 
      },
      calc() {
        if (this.requestParam.ospos.y < 0 || this.requestParam.ospos.y > 90 ||
          this.requestParam.tspos.y < 0 || this.requestParam.tspos.y > 90
        ) {
          this.$message.error('纬度范围0-90');
          return;
        }
        if (this.requestParam.ospos.x < 0 || this.requestParam.ospos.x > 180 ||
          this.requestParam.tspos.x < 0 || this.requestParam.tspos.x > 180
        ) {
          this.$message.error('经度范围0-180');
          return;
        }
        var parm = JSON.parse(JSON.stringify(this.requestParam))
        if (this.isosposS == '1') {
          parm.ospos.y = -this.requestParam.ospos.y
        } else {
          parm.ospos.y = this.requestParam.ospos.y
        }
        if (this.isosposW == '1') {
          parm.ospos.x = this.requestParam.ospos.x
        } else {
          parm.ospos.x = -this.requestParam.ospos.x
        }

        if (this.istsposS == '1') {
          parm.tspos.y = -this.requestParam.tspos.y
        } else {
          parm.tspos.y = this.requestParam.tspos.y
        }
        if (this.istsposW == '1') {
          parm.tspos.x = this.requestParam.tspos.x
        } else {
          parm.tspos.x = -this.requestParam.tspos.x
        }

        axios.post("http://39.105.117.173:8001/Cpatcpa/calc", parm)
          .then(res => {
            res.data.dRange = res.data.dRange.toFixed(4)
            res.data.dBearing = res.data.dBearing.toFixed(4)
            res.data.dCPA = res.data.dCPA.toFixed(4)
            res.data.dTCPA = res.data.dTCPA.toFixed(4)
            this.result = res.data
          })
          .catch(error => {
            alert("发生错误" + error);
          });
      }
    }
  };

</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/CpaTcpa/cpatcpa.vue